import { combineReducers } from 'redux';

import app from './app';
import auth from './auth';
import calculator from './calculator';
import cards from './cards';
import chat from './chat';
import extra from './extra';
import form from './form';
import history from './history';
import language from './language';
import login from './login';
import messages from './messages';
import request from './request';
import send from './send';

export default combineReducers({
    app,
    calculator,
    auth,
    language,
    form,
    messages,
    history,
    send,
    request,
    chat,
    cards,
    extra,
    login,
});
